import { render, staticRenderFns } from "./PointGpayError.vue?vue&type=template&id=0cb0c976"
import script from "./PointGpayError.vue?vue&type=script&lang=js"
export * from "./PointGpayError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports